export function removeObjProperties<T extends object>(obj: T, ...keys: (keyof T)[]) {
  const newObj = structuredClone(obj);

  keys?.forEach(key => {
    delete newObj?.[key as keyof typeof newObj];
  });

  return newObj;
}

export function removeObjEmptyValues<T extends object>(obj: T) {
  const result: T | {} = {};

  Object.entries(obj).forEach(([key, value]) => {
    if (value) {
      if (Array.isArray(value)) {
        if (value.length > 0) {
          // @ts-expect-error
          result[key] = value;
        }
      } else if (typeof value === 'object') {
        const cleanedValue = removeObjEmptyValues(value);

        if (Object.keys(cleanedValue).length > 0) {
          // @ts-expect-error
          result[key] = cleanedValue;
        }
      } else {
        // @ts-expect-error
        result[key] = value;
      }
    }
  });

  return result;
}

export function parsePayloadObj<T extends object>(obj: T) {
  return {
    ...obj,
    filter: {
      ...(obj as { filter: object }).filter,
      buildings: (obj as { filter: { buildings: string[] } })?.filter?.buildings?.map(i => JSON.parse(i))
    }
  };
}
